<nav
  class="
    shadow-sm
    navbar navbar-expand-lg navbar-light
    bg-light
    fixed-top
    border-bottom
  "
>
  <div class="container-fluid d-flex justify-content-center">
    <a class="navbar-brand m-0" [routerLink]="['/home']">
      <b class="text-danger user-select-none">uOrder</b>
    </a>
  </div>
</nav>
